var exports = {
  "k": "x112a1f60--e01145--container",
};

module.exports = exports;
